module.exports = "/_next/static/images/header-bg-c5bd060841eb2788affada35bceb4259.png";